exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.segments a[data-v-4cf92444] {\n  cursor: pointer;\n}\n", ""]);

// exports
